import type { LotterySiteSettings } from '../types/lottery';

const SITE_SETTINGS_CACHE_KEY = 'lottery_site_settings_cache';

function normalizeText(value: unknown) {
  return typeof value === 'string' ? value.trim() : '';
}

function normalizeSiteSettings(value?: null | Partial<LotterySiteSettings>): LotterySiteSettings | null {
  if (!value) {
    return null;
  }
  return {
    site_name: normalizeText(value.site_name),
    site_short_name: normalizeText(value.site_short_name),
    site_url: normalizeText(value.site_url),
    site_logo: normalizeText(value.site_logo),
    site_favicon: normalizeText(value.site_favicon),
    site_notice: normalizeText(value.site_notice),
    site_description: normalizeText(value.site_description),
    service_contact: normalizeText(value.service_contact),
    company_address: normalizeText(value.company_address),
    copyright_text: normalizeText(value.copyright_text),
    seo_keywords: normalizeText(value.seo_keywords),
    seo_description: normalizeText(value.seo_description),
  };
}

export function readCachedSiteSettings(): LotterySiteSettings | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return normalizeSiteSettings(JSON.parse(window.localStorage.getItem(SITE_SETTINGS_CACHE_KEY) || 'null'));
  } catch {
    return null;
  }
}

export function writeCachedSiteSettings(value?: null | Partial<LotterySiteSettings>): LotterySiteSettings | null {
  const normalized = normalizeSiteSettings(value);
  if (!normalized || typeof window === 'undefined') {
    return normalized;
  }
  try {
    window.localStorage.setItem(SITE_SETTINGS_CACHE_KEY, JSON.stringify(normalized));
  } catch {
    // Ignore storage failures and keep runtime state usable.
  }
  return normalized;
}

export function resolveSiteName(settings: LotterySiteSettings | null) {
  return normalizeText(settings?.site_name) || normalizeText(settings?.site_short_name);
}

export function resolveSiteShortName(settings: LotterySiteSettings | null) {
  return normalizeText(settings?.site_short_name) || normalizeText(settings?.site_name);
}
